import { Component, inject } from '@angular/core';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ServiceState } from '@brightside-web/desktop/data-access/service-inventory';

@Component({
    selector: 'brightside-web-mpap-pending-card',
    imports: [BrightsideUiModule],
    templateUrl: './mpap-pending-card.component.html',
    styleUrl: './mpap-pending-card.component.css'
})
export class MpapPendingCardComponent {
  data: { route: string; state: string };
  actionCardConfig: ActionCardConfigInterface;

  private _translateSvc = inject(TranslateService);
  private _router = inject(Router);

  ngOnInit(): void {
    if (this.data.state === ServiceState.PENDING) {
      this.actionCardConfig = {
        label: this._translateSvc.instant('TAKE_ACTION'),
        labelSub: this._translateSvc.instant('MPAP_PENDING_MINUTES'),
        title: this._translateSvc.instant('MPAP_PENDING_TITLE'),
        body: this._translateSvc.instant('MPAP_PENDING_DESC'),
        labelSubRemoveDash: true,
        cardStyle: 'small',
        labelIcon: 'icon-actions',
        marginBottom: 'small'
      }
    } else if (this.data.state === ServiceState.UPLOAD) {
      this.actionCardConfig = {
        label: this._translateSvc.instant('TAKE_ACTION'),
        labelSub: this._translateSvc.instant('MPAP_PENDING_MINUTES'),
        title: this._translateSvc.instant('MPAP_UPLOAD_TITLE'),
        body: this._translateSvc.instant('MPAP_UPLOAD_DESC'),
        labelSubRemoveDash: true,
        cardStyle: 'small',
        labelIcon: 'icon-actions',
        marginBottom: 'small'
      }
    }
  }

  navigate() {
    this._router.navigateByUrl(this.data.route);
  }
}
